/**
 * Vineyards Page
 */

export default function HWY_Vineyards() {
	const selectors = {
		container: ".page-vineyards",
		carousel: ".page-vineyards .vineyards",
		current: ".page-vineyards .center .vineyard-image",
	};

	this.init = () => {
		createVineyardsCarousel();
	};

	const createVineyardsCarousel = () => {
		const el = jQuery(selectors.carousel);

		el.owlCarousel({
			autoplay: true,
			autoplayTimeout: 2000,
			dots: false,
			items: 1,
			center: true,
			loop: true,
			nav: true,
			navText: [
				'<img src="/wp-content/themes/commerce7/assets/images/SVG/Prev.svg" alt="Go to the previous item">',
				'<img src="/wp-content/themes/commerce7/assets/images/SVG/Next.svg" alt="Go to the next item">',
			],
			responsive: {
				0: {
					items: 1,
					margin: 0,
					stagePadding: 65,
				},
				768: {
					items: 3,
					margin: 20,
					stagePadding: 0,
				},
			},
			smartSpeed: 700,
			onInitialized: setBackgroundImage,
		});
		el.on("changed.owl.carousel", function (event) {
			const index = event.item.index + 1;
			const image = jQuery(
				".page-vineyards .owl-item:nth-child(" +
					index +
					") .vineyard-image"
			).data("image");
			jQuery(selectors.container).css({
				"background-image": "url(" + image + ")",
			});
		});
	};

	const setBackgroundImage = () => {
		const image = jQuery(selectors.current).data("image");
		jQuery(selectors.container).css({
			"background-image": "url(" + image + ")",
		});
	};
}
